<template>
  <div 
    v-if="isLoad" 
    class="box-placeholder"
  >
    <div class="excerpt">
      <div class="text" v-for="i in loops" :key="i.toString()" :id="i" />
    </div>
  </div>
</template>

<script>
export default {
    props: {
        isLoad : {
            type: String,
            default: null
        },
        line : {
            type: Number,
            default: 9
        }
    },
    computed : {
      loops() {
        return [...Array(this.line).keys()]
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/plugins/PlaceholderContent.vue